import React from "react";
import { useMicrositeContext } from "./MicrositeLayout";
import { Card, CardContent } from "../../components/ui/card";
import { MapPin, Phone, Clock, AlertCircle } from "lucide-react";

export default function MicrositeAbout() {
  const { clinic } = useMicrositeContext();
  const primary = clinic.primary_color || "#2563EB";
  return (
    <div data-testid="microsite-about">
      <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-2" style={{ fontFamily: "Manrope" }}>About {clinic.name}</h1>
      <p className="text-slate-500 mb-8 max-w-2xl">
        {clinic.tagline || "Compassionate, modern healthcare for our community."}
      </p>
      <div className="grid sm:grid-cols-2 gap-4">
        <Card className="border-slate-200">
          <CardContent className="p-6 space-y-3">
            <div className="text-xs uppercase tracking-wide font-semibold" style={{ color: primary }}>Location</div>
            {clinic.address ? (
              <div className="flex items-start gap-2 text-slate-700"><MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />{clinic.address}</div>
            ) : <div className="text-slate-400 italic text-sm">Address not provided</div>}
            {clinic.phone && (
              <div className="flex items-center gap-2 text-slate-700"><Phone className="w-4 h-4" /> {clinic.phone}</div>
            )}
          </CardContent>
        </Card>
        <Card className="border-slate-200">
          <CardContent className="p-6">
            <div className="text-xs uppercase tracking-wide font-semibold mb-2" style={{ color: primary }}>Status</div>
            {clinic.status === "open" ? (
              <div className="text-emerald-700 font-medium flex items-center gap-2"><Clock className="w-4 h-4" /> Open for appointments</div>
            ) : (
              <div className="text-amber-700 font-medium flex items-center gap-2">
                <AlertCircle className="w-4 h-4" />
                {clinic.status?.toUpperCase()}{clinic.status_until ? ` until ${clinic.status_until}` : ""}
              </div>
            )}
            {clinic.status_message && (
              <div className="text-sm text-slate-500 mt-2">{clinic.status_message}</div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
